import { AppConfig } from "environement";

export const heightWithToolbar = "calc(calc(var(--vh, 1vh) * 100) - 86px)";
export const piecesEnabled = AppConfig.app.piecesEnabled ?? true;
